<div class="login-integration-page">
  @if (requireSelectAccount()) {
  <div class="select-accounts">
    <div class="select-accounts__title" data-testid="accountSelectTitle">
      Você tem acesso a mais de uma conta
    </div>
    <div class="select-accounts__subtitle">
      Escolha abaixo com qual gostaria de entrar
    </div>
    <div class="select-accounts__list">
      @for(account of accounts(); track account.userId) {
      <div
        class="select-accounts__list__item"
        [attr.data-testid]="'accountSelectRow-' + account.userId"
        [class.select-accounts__list__item--blocked]="account.blocked"
        (click)="selectAccountToLogin(account)"
      >
        <div
          class="select-accounts__list__item-picture"
          [class.select-accounts__list__item-picture--company]="isCompany(account)"
        >
          @if (isCompany(account)) {
          <app-icon name="office-building-solid" color="currentColor" />
          } @else {
          {{ getUserAbreviation(account) }}
          }
        </div>
        <div class="select-accounts__list__item-details">
          @if (hasName(account)) {
          <div
            class="select-accounts__list__item-details__name"
            [attr.title]="account.name"
            [attr.data-testid]="'accountSelectMessageName-' + account.userId"
          >
            {{ account.name }}
          </div>
          }
          @if (isCompany(account)) {
          <div
            class="select-accounts__list__item-details__email"
            [class.select-accounts__list__item-details__email--primary]="!hasName(account)"
            [attr.data-testid]="'accountSelectMessageCnpj-' + account.userId"
          >
            CNPJ {{ account.userMetadata?.cpf ?? '' | mask: 'AA.AAA.AAA/AAAA-00' }}
          </div>
          <div
            class="select-accounts__list__item-details__type"
            [attr.data-testid]="'accountSelectBadgeCompany-' + account.userId"
          >
            <strong>Pessoa jurídica</strong>
          </div>
          } @else {
          <div class="select-accounts__list__item-details__email">
            {{ account.email }}
          </div>
          <div class="select-accounts__list__item-details__type">
            <span> Conta </span>
            <strong>
              {{ account.internal ? "interna" : "externa" }}
            </strong>
          </div>
          }
        </div>
        @if (account === lastAccessed()) {
        <div class="select-accounts__list__item-last" data-testid="accountSelectBadgeLastAccess">
          Último acesso
        </div>
        }
      </div>
      }
      @if (canCreateAccount()) {
      <button
        type="button"
        class="select-accounts__list__new"
        data-testid="accountSelectButtonCreate"
        (click)="createNewAccount()"
      >
        Criar conta nova
      </button>
      }
    </div>
  </div>
  }
</div>
